import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Dependencies
import moment from 'moment';

// Components
import Drawer from '../Drawer/Drawer';
import LoadMore from '../Common/LoadMore';
import * as icons from '../Icons/Icons';

const ExamApprovals = observer(class ExamApprovals extends React.Component {
  constructor() {
    super();
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerContent: null,
      drawerOpen: false,
      courseSid: null
    }

    this.props.store.ExamStore.getExamApprovals();
  }

  componentDidMount() {
    if(getURLSegment(this, 2) === 'review') {
      toggleDrawer(null, this, 'ExamException');
    }
  }

  applyFilters(e) {
    e.preventDefault();

    let filters = {};

    const fname = this.fname.value;
    const lname = this.lname.value;

    if(fname) {
      filters.instructorFirstName = fname;
    }

    if(lname) {
      filters.instructorLastName = lname;
    }

    if(fname || lname) {
      this.props.store.ExamStore.getExamApprovals(filters);
    } else {
      this.resetFilters();
    }
  }

  resetFilters() {
    this.fname.value = '';
    this.lname.value = '';

    this.props.store.ExamStore.getExamApprovals();
  }

  renderResults() {
    const { translation } = this.props;
    const { ExamStore, SessionStore } = this.props.store;
    const { userTimezone } = this.props.store.SessionStore;

    if(SessionStore.loadingCalls.indexOf('GetExamApprovals') < 0) {
      if(ExamStore.examApprovals.length > 0) {
        return (
          <table>
            <thead>
              <tr>
                <th id="heading-title" className="subtitle" scope="col">
                  {translation.title}
                </th>
                <th id="heading-course" className="subtitle" scope="col">
                  {translation.course}
                </th>
                <th id="heading-instructor" className="subtitle" scope="col">
                  {translation.instructor}
                </th>
                <th id="heading-student" className="subtitle" scope="col">
                  {translation.student}
                </th>
                <th id="heading-starts" className="subtitle" scope="col">
                  {translation.starts}
                </th>
                <th id="heading-ends" className="subtitle" scope="col">
                  {translation.ends}
                </th>
                <th id="heading-dates" className="subtitle" scope="col">
                  {translation.actions}
                </th>
              </tr>
            </thead>
            <tbody>
              {ExamStore.examApprovals.map(
                (approval, i) =>
                <tr key={i}>
                  <td aria-labelledby="heading-title">
                    <Link
                      to={
                        `/${getURLSegment(this, 1)}/review/exam/${approval.examSid}/configuration/${approval.sid}/course/${approval.course.sid}?exception=${approval.enrollment ? 'true' : 'false'}`
                      }
                      title={`Review ${approval.exam.title}`}
                    >
                      {approval.exam.title}
                    </Link>

                    {/* Change request */}
                    {approval.referenceExamConfigurationSid &&
                      <span className="title">{translation.change_request}</span>
                    }

                    {/* Student accommodation */}
                    {approval.enrollment &&
                      <span className="title">
                        {approval.enrollment.user.lastName}, {approval.enrollment.user.firstName}
                      </span>
                    }
                  </td>
                  <td aria-labelledby="heading-course">
                    {approval.course.title}
                  </td>
                  <td aria-labelledby="heading-instructor">
                    {approval.instructor &&
                      <span>
                        {approval.instructor.firstName} {approval.instructor.lastName}
                      </span>
                    }
                  </td>
                  <td aria-labelledby="heading-student">
                    {approval.enrollment &&
                      <span>
                        {approval.enrollment.user.lastName}, {approval.enrollment.user.firstName}
                      </span>
                    }
                  </td>
                  <td aria-labelledby="heading-starts" className="number">
                    {moment.utc(approval.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                  </td>
                  <td aria-labelledby="heading-ends" className="number">
                    {moment.utc(approval.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                  </td>
                  <td>
                    <Link
                      className="btn--outline"
                      to={
                        `/${getURLSegment(this, 1)}/review/exam/${approval.examSid}/configuration/${approval.sid}/course/${approval.course.sid}?exception=${approval.enrollment ? 'true' : 'false'}`
                      }
                    >
                      <icons.iconEye />
                      {translation.review}
                    </Link>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )
      } else {
        return (
          <span className="no-results">{translation.no_results}</span>
        )
      }
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { examApprovals, examApprovalsNext } = this.props.store.ExamStore;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        <form className="filter" onSubmit={(e) => {this.applyFilters(e)}}>
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li><legend>{translation.filter_heading}:</legend></li>
                <li>
                  <label className="meta" htmlFor="filter-fname">
                    {translation.instructor_fname}
                  </label>
                  <input
                    type="text"
                    id="filter-fname"
                    placeholder={translation.instructor_fname}
                    ref={(input) => {this.fname = input}}
                    // onBlur={this.applyFilters}
                  />
                </li>
                <li>
                  <label className="meta" htmlFor="filter-lname">
                    {translation.instructor_lname}
                  </label>
                  <input
                    type="text"
                    id="filter-lname"
                    placeholder={translation.instructor_lname}
                    ref={(input) => {this.lname = input}}
                    // onBlur={this.applyFilters}
                  />
                </li>
              </ul>
            </fieldset>

            <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
          </div>
        </form>

        <div className="wrap">
          {this.renderResults()}
        </div>

        {examApprovalsNext &&
          <LoadMore
            url={examApprovalsNext}
            group={examApprovals}
            text="Load more results"
            {...this.props}
          />
        }

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          approval={true}
          courseSid={this.state.courseSid}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('ExamApprovals')(ExamApprovals);



// WEBPACK FOOTER //
// ./src/app/components/Approvals/ExamApprovals.js